import { defineStore } from 'pinia'

export const useBreadcrumbStore = defineStore({
  id: 'breadcrumbs',
  state: () => ({
    breadcrumbs: [],
  }),
  getters: {
    getBreadcrumbs(state) {
          return state.breadcrumbs;
    }
  }, 
  actions: {
     setBreadcrumb(crumbs) {
          this.breadcrumbs=crumbs;
      }
  }
})